import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";

// The map credit, shared by every map (Gaps by keyword, the search page).
// OpenStreetMap (and, on the report map, the Wikipedia boundaries) require
// the credit, so it is shown in full when the map opens, then folds into a
// small "i" after a few seconds or as soon as the map is used; hovering the
// "i" shows it again. Styles: .map-credit-folded in src/index.css.
//
//   const [creditFolded, foldCredit] = useFoldingCredit();
//   <div className={creditFolded ? "map-credit-folded" : ""} onPointerDown={foldCredit} onWheel={foldCredit}>
//     <MapContainer ...><NoLeafletPrefix /> ...</MapContainer>
//   </div>

const CREDIT_SHOWN_FOR_MS = 5000;

export function useFoldingCredit() {
  const [folded, setFolded] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setFolded(true), CREDIT_SHOWN_FOR_MS);
    return () => clearTimeout(timer);
  }, []);
  return [folded, () => setFolded(true)];
}

// Drops Leaflet's own "Leaflet" link from the credit (not required by its licence).
export function NoLeafletPrefix() {
  const map = useMap();
  useEffect(() => {
    if (map.attributionControl) map.attributionControl.setPrefix(false);
  }, [map]);
  return null;
}
